import React from "react"
import { Theme } from "@emotion/react"
import { Tooltip } from "@ncs/web-legos"
import { bottomFooterStyle, termsStyle, bottomFooterStyleLight, termsStyleLight } from "./style"

interface BottomFooterProps {
	isLight?: boolean
}
const BottomFooter: React.FC<BottomFooterProps> = ({ isLight = false }) => (
	<div css={isLight ? bottomFooterStyleLight : bottomFooterStyle}>
		<div css={isLight ? termsStyleLight : termsStyle}>
			<a
				href="https://ncswash.com/wp-content/uploads/2023/06/NCS-PO-STANDARD-TERMS-AND-CONDITIONS-1.pdf"
				target="_blank"
				rel="noreferrer"
			>
				Terms & Conditions
			</a>
			<a href="https://ncswash.com/privacy-policy/" target="_blank" rel="noreferrer">
				Privacy Policy
			</a>
		</div>
		<Tooltip title={`Release Version : ${import.meta.env.VITE_RELEASE_VERSION || ""}`}>
			<p>
				© {new Date().getFullYear()} National Carwash Solutions, Inc. All Rights Reserved.
			</p>
		</Tooltip>
	</div>
)

export default BottomFooter
